import buildSlider from './slider';

const options = {
  align: 'start',
  containScroll: 'trimSnaps',
  inViewThreshold: 0.2,
  breakpoints: {
    '(min-width: 0px)': {
      slidesToScroll: 1,
    },
    '(min-width: 1181px)': {
      slidesToScroll: 3,
      watchDrag: (emblaApi) => emblaApi.slideNodes().length > 3,
    },
  },
};

buildSlider('.slider-paragraph-featured-product', options);
